var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { appStrings } from '@backrs_ui/common-ui/src/assets/appStrings';
import { ReactComponent as BackrsWithText } from '@backrs_ui/common-ui/src/assets/images/backrs-with-text.svg';
import CheckIcon from '@mui/icons-material/Check';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import { Box, Checkbox, FormControlLabel, Typography } from '@mui/material';
import { useForm, Controller } from 'react-hook-form';
import { TermsAndConditions } from './TermsAndConditions';
import { BackrsForm } from '../BackrsForm/BackrsForm';
var REGISTER_STRINGS = appStrings.modules.register;
export var Register = function (_a) {
    var _b, _c, _d;
    var handleRegistration = _a.handleRegistration, errorMessage = _a.errorMessage, registerId = _a.registerId, preFilledData = _a.preFilledData;
    var _e = useState(false), isPasswordVisible = _e[0], setIsPasswordVisible = _e[1];
    var _f = useState(false), isRegistering = _f[0], setIsRegistering = _f[1];
    var defaultRegistrationValues = __assign({ first_name: (_b = preFilledData === null || preFilledData === void 0 ? void 0 : preFilledData.first_name) !== null && _b !== void 0 ? _b : '', last_name: (_c = preFilledData === null || preFilledData === void 0 ? void 0 : preFilledData.last_name) !== null && _c !== void 0 ? _c : '', phone: '', email: (_d = preFilledData === null || preFilledData === void 0 ? void 0 : preFilledData.email) !== null && _d !== void 0 ? _d : '', password: '', invite_code: '', is_fourteen_plus: '' }, (registerId && { register_id: registerId }));
    var methods = useForm({
        defaultValues: defaultRegistrationValues,
    });
    var fields = [
        {
            id: 'first_name',
            name: 'first_name',
            placeholder: REGISTER_STRINGS.firstNamePlaceholder,
            type: 'text',
            autoComplete: 'firstName',
            autoFocus: true,
            rules: {
                required: REGISTER_STRINGS.error.firstNameRequired,
            },
        },
        {
            id: 'last_name',
            name: 'last_name',
            placeholder: REGISTER_STRINGS.lastNamePlaceholder,
            type: 'text',
            autoComplete: 'lastName',
            rules: {
                required: REGISTER_STRINGS.error.lastNameRequired,
            },
        },
        {
            id: 'phone',
            name: 'phone',
            placeholder: REGISTER_STRINGS.phonePlaceholder,
            type: 'tel',
            autoComplete: 'phone',
            rules: {
                required: REGISTER_STRINGS.error.phoneRequired,
                pattern: { value: /^\d{10}$/, message: REGISTER_STRINGS.error.invalidPhone },
            },
        },
        {
            id: 'email',
            name: 'email',
            placeholder: REGISTER_STRINGS.emailPlaceholder,
            type: 'text',
            autoComplete: 'email',
            rules: {
                required: REGISTER_STRINGS.error.emailRequired,
                pattern: { value: /^\S+@\S+$/i, message: REGISTER_STRINGS.error.invalidEmail },
            },
        },
        {
            id: 'password',
            name: 'password',
            placeholder: REGISTER_STRINGS.passwordPlaceholder,
            type: isPasswordVisible ? 'text' : 'password',
            autoComplete: 'current-password',
            icon: {
                type: 'RIGHT_ICON',
                rightIcon: isPasswordVisible ? 'EyeOff' : 'Eye',
                onRightIconClick: function () {
                    setIsPasswordVisible(function (prev) { return !prev; });
                    setTimeout(function () {
                        setIsPasswordVisible(false);
                    }, 5000);
                },
            },
            rules: { required: REGISTER_STRINGS.error.passwordRequired },
        },
        {
            id: 'invite_code',
            name: 'invite_code',
            placeholder: REGISTER_STRINGS.inviteCodePlaceholder,
            type: 'text',
        },
    ];
    var handleSubmission = function (data) {
        setIsRegistering(true);
        var transformedData = {
            first_name: data.first_name,
            last_name: data.last_name,
            phone: data.phone,
            email: data.email,
            password: data.password,
            invite_code: data.invite_code ? data.invite_code : null,
            is_fourteen_plus: !!data.is_fourteen_plus,
            register_id: registerId !== null && registerId !== void 0 ? registerId : null,
        };
        handleRegistration(transformedData);
    };
    return (_jsxs(Box, { sx: containerStyle, children: [_jsx(Box, { sx: responsiveBackrsLogoStyle, children: _jsx(BackrsWithText, {}) }), _jsxs(Box, { sx: loginFormStyle, children: [_jsx(Typography, { variant: "display-sm-bold", sx: titleStyle, children: REGISTER_STRINGS.title }), _jsx(BackrsForm, { fields: fields, onSubmit: handleSubmission, buttonLabel: REGISTER_STRINGS.buttonLabel, methods: methods, isLoading: isRegistering, children: _jsx(FormControlLabel, { label: REGISTER_STRINGS.ageCertification, sx: checkboxLabelStyle, control: _jsx(Controller, { name: "is_fourteen_plus", control: methods.control, rules: { required: '', validate: function (value) { return "".concat(value) === 'true'; } }, render: function (_a) {
                                    var controllerField = _a.field;
                                    return (_jsx(Checkbox, __assign({}, controllerField, { checked: !!controllerField.value, sx: checkboxStyle, icon: _jsx(CheckBoxOutlineBlankIcon, {}), checkedIcon: _jsx(CheckIcon, {}) })));
                                } }, "is_fourteen_plus") }) }), _jsx(Box, { sx: termsAndConditionsContainerStyle, children: _jsx(TermsAndConditions, {}) }), errorMessage && (_jsx(Box, { mt: 2, color: function (_a) {
                            var backrs = _a.backrs;
                            return backrs.colors['Colors/Text/text-error-primary'];
                        }, children: errorMessage }))] })] }));
};
var containerStyle = function (_a) {
    var backrs = _a.backrs;
    return ({
        height: '100svh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        px: {
            xs: backrs.spacing['spacing-lg'],
            sm: backrs.spacing['spacing-2xl'],
        },
    });
};
var titleStyle = function (_a) {
    var _b, _c;
    var backrs = _a.backrs, typography = _a.typography;
    return ({
        color: backrs.colors['Colors/Text/text-brand-primary'],
        mb: {
            xs: backrs.spacing['spacing-md'],
            sm: backrs.spacing['spacing-4xl'],
        },
        fontSize: {
            xs: (_b = typography['display-xs-bold']) === null || _b === void 0 ? void 0 : _b.fontSize,
            sm: (_c = typography['display-md-bold']) === null || _c === void 0 ? void 0 : _c.fontSize,
        },
    });
};
var loginFormStyle = function (_a) {
    var backrs = _a.backrs;
    return ({
        backgroundColor: backrs.colors['Colors/Base/White'],
        paddingX: backrs.spacing['spacing-md'],
        paddingY: {
            xs: backrs.spacing['spacing-none'],
            sm: backrs.spacing['spacing-3xl'],
        },
        borderRadius: backrs.radius['radius-md'],
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        maxWidth: '100%',
        width: '100%',
        boxSizing: 'border-box',
        '@media (min-width: 300px)': {
            paddingX: backrs.spacing['spacing-3xl'],
            paddingY: backrs.spacing['spacing-2xl'],
        },
        '@media (min-width: 600px)': {
            maxWidth: '500px',
            paddingX: backrs.spacing['spacing-8xl'],
            paddingY: backrs.spacing['spacing-7xl'],
        },
        boxShadow: backrs.shadows['shadow-3xl'],
        border: "3px solid ".concat(backrs.colors['Colors/Base/Black']),
    });
};
var responsiveBackrsLogoStyle = function (_a) {
    var backrs = _a.backrs;
    return ({
        width: '100%',
        maxWidth: '175px',
        padding: backrs.spacing['spacing-md'],
        paddingTop: backrs.spacing['spacing-2xl'],
        marginBottom: {
            xs: backrs.spacing['spacing-xl'],
            sm: backrs.spacing['spacing-2xl'],
        },
    });
};
var checkboxLabelStyle = function (_a) {
    var backrs = _a.backrs;
    return ({
        outline: 'none',
        padding: backrs.spacing['spacing-none'],
        alignItems: 'center',
        '.MuiFormControlLabel-label': {
            color: backrs.colors['Colors/Text/text-brand-primary'],
            fontSize: '0.75rem',
        },
    });
};
var checkboxStyle = function (_a) {
    var backrs = _a.backrs;
    return ({
        '&.Mui-checked': {
            color: 'white',
        },
        '& .MuiSvgIcon-root': {
            fontSize: '1.125rem',
            border: "2px solid ".concat(backrs.colors['Colors/Text/text-brand-primary']),
            backgroundColor: backrs.colors['Colors/Text/text-brand-primary'],
        },
        padding: '11px 0px 11px 11px',
    });
};
var termsAndConditionsContainerStyle = function (_a) {
    var backrs = _a.backrs;
    return ({
        mt: backrs.spacing['spacing-2xl'],
    });
};
